var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fd-group"},_vm._l((_vm.config.values),function(item,i){return _c(item.type + 'View',_vm._g({key:item.type + '_' + i,tag:"component",attrs:{"config":item,"value":item.value}},item.events))}))}
var staticRenderFns = []

export { render, staticRenderFns }